import { AfterContentInit, Component, Inject, Input, OnDestroy, ViewChild } from "@angular/core";
import { BooleanAttribute } from "@hex/angular/decorators";
import { Subscription } from "rxjs";
import { ICommonFilterActionCreator } from "../../redux/actions.interface";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { multiselectFilterReducerFactory } from "./reducer";
import { MULTISELECT_FILTER_STATE_PROP } from "./state-props";

import { NS_UIState } from "../../types/uistate.types";

@Component({
    selector: "common-multiselect-filter",
    templateUrl: "./common-multiselect-filter.component.html",
    styleUrls: ["./common-multiselect-filter.component.scss"],
})
export class CommonMultiselectFilterComponent implements AfterContentInit, OnDestroy {
    @Input() public listActions: ICommonFilterActionCreator<any>;
    @Input() public initialState: NS_UIState.ICommonToggleFilterState;
    @Input() public fieldToFilter: string;
    @Input() @BooleanAttribute() public keepStateAliveOnDestroy = false;

    @ViewChild("actions", { static: true }) public actions;

    public filters: any[];
    public selectedLabels: string;
    private state$: Subscription;

    constructor(
        private ngRedux: ImmutableRedux<any>,
        @Inject(MULTISELECT_FILTER_STATE_PROP) public rootProp,
    ) { }

    public ngAfterContentInit() {
        if (!this.keepStateAliveOnDestroy && !this.ngRedux.checkState(this.rootProp, this.stateProp)) {
            this.ngRedux.registerComponent(multiselectFilterReducerFactory, this.rootProp, this.stateProp, this.initialState);
        }

        this.state$ = this.ngRedux.select(this.rootProp, this.stateProp).subscribe((state) => {
            this.filters = state.filters;
            const toggledKeys = this.filters.filter((f) => f.state).map((f) => f.label);
            const firstLabel = toggledKeys[0];
            const additionalLabels = toggledKeys.slice(1);
            if (additionalLabels.length && firstLabel != null) {
                this.selectedLabels = `${firstLabel}+${additionalLabels.length}`;
            } else if (firstLabel != null) {
                this.selectedLabels = `${firstLabel}`;
            } else {
                this.selectedLabels = "";
            }
        });
    }

    public ngOnDestroy() {
        this.state$.unsubscribe();
    }

    public get stateProp() {
        return `${this.listActions.rootProp}::${this.listActions.stateProp}::${this.fieldToFilter}`;
    }

    public reset() {
        if (!this.keepStateAliveOnDestroy) {
            this.actions.reset();
        }
    }

    public handleClearFilter(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.actions.clearAllFilters();
    }
}
